import * as React from 'react';

import { createIcon } from '../Icon';
export const ThermometerIcon = createIcon(
  <path d="M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z" />,
  'ThermometerIcon'
);
